export default __webpack_public_path__ + "594164cd0dd2d2fdc75a3c6eadf91ad5.png";